module.exports = __webpack_public_path__ + "img/twitter.eb57f467.svg";